import { endpoints, host } from '@config/endpoints';
import request from './request';

export const exportTopUnemployedJobPosts = async (urlDataAPI:any) => {
    const { exportType, hubIds } = urlDataAPI;
    const { path, method } = endpoints.laborDemandPulse.exportTopUnemployedJobPosts;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { exportType, hubIds },
            {
                responseType: "blob"
            },
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};
